import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router';

export const BlogRelatedTitle = styled(Typography)(() => ({
    fontFamily: 'Inter',
    marginTop: '2em',
    fontSize: '1.2em',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    textTransform: 'capitalize',
    marginBottom: '1.2em',
}));

export const BlogRelatedPost = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1em',
}));

export const BlogRelatedPostMain = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '1em',
    cursor: 'pointer',
}));

export const BlogRelatedPostImage = styled('img')(() => ({
    width: '3.6em',
    height: '3.6em',
    objectFit: 'cover',
    borderRadius: '.5em',
}));

export const BlogRelatedPostTitle = styled(Link)(({ theme }) => ({
    fontFamily: 'Inter',
    fontSize: '1em',
    color: theme.palette.secondary.main,
    fontWeight: 500,
    textTransform: 'capitalize',
    textDecoration: 'none',
    '@media (max-width: 768px)': {
        maxWidth: '15em',
    },
}));

